import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { utils } from '@ltfe/ltfe-core-lib';
import { LBSbusinessId,sceneId } from '../common/utils';
import { get } from '../common/fetch';
import CityList from '../components/city/city';
import { getWebLocation, withLocation } from '../common/getWebLbs';
import sgmReport from '../common/sgmUtil';

const { getLBS } = utils;

class City extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            all_city: {},
            hot_city: [{ cityId: '11', cityPy: 'bj', cityName: '北京', fullCityPy: 'beijing' }, { cityId: '12', cityPy: 'tj', cityName: '天津', fullCityPy: 'tianjin' }, { cityId: '31', cityPy: 'sh', cityName: '上海', fullCityPy: 'shanghai' }, { cityId: '3201', cityPy: 'nj', cityName: '南京', fullCityPy: 'nanjing' }, { cityId: '4201', cityPy: 'wh', cityName: '武汉', fullCityPy: 'wuhan' }, { cityId: '4401', cityPy: 'gz', cityName: '广州', fullCityPy: 'guangzhou' }, { cityId: '4403', cityPy: 'sz', cityName: '深圳', fullCityPy: 'shenzhen' }, { cityId: '5101', cityPy: 'cd', cityName: '成都', fullCityPy: 'chengdu' }, { cityId: '5102', cityPy: 'cq', cityName: '重庆', fullCityPy: 'chongqing' }, { cityId: '6101', cityPy: 'xa', cityName: '西安', fullCityPy: 'xian' }, { cityId: '200078', cityPy: 'hz', cityName: '杭州', fullCityPy: 'hangzhou' }]
        };
        this._setCity = this._setCity.bind(this);
    }

    render() {
        const { all_city, hot_city } = this.state;
        const { cur_city, lbsCity } = this.props;

        return (
            <CityList
                cur_city={ cur_city }
                city_list={ all_city }
                hot_city={ hot_city }
                reCity={ this._setCity }
                lbs={ lbsCity }
                getLbs={ this._getPosition }
            />
        );
    }

    componentDidMount() {
        get('getAllCityList', {}).then((res) => {
            this.setState({
                all_city: res.data
            });
        });
    }

    _setCity(data) {
        this.props.dispatch({
            type: 'cur_city',
            cur_city: {
                ...data,
                auto_chose: 1
            }
        });
    }

    _getPosition = async() => {
        const { dispatch } = this.props;
        console.log(`准备定位`, LBSbusinessId, sceneId);
        try {
            await withLocation();
            const loc = await getWebLocation();
            const { lon, lat } = loc;
            const res = await get('getCityInfoByLocation', {
                lon,
                lat,
                ip: 'l'
            });
            console.log(`定位结果`, res);
            dispatch({
                type: 'lbsCity',
                lbsCity: res.data,
                cur_city: res.data
            });

            if(!lon || !lat){
                sgmReport('1001', {function_id: 'getCityInfoByLocation',message:'缺少参数lon/lat'}, 3)
            }
        } catch (e) {
            console.log(`定位失败`, e);
            throw new Error('定位失败：您未允许京东获取定位权限，您可在系统设置中开启');
        }
    }
}

City.contextTypes = {
    router: PropTypes.object
};
const select = (state) => {
    const props = state.index;
    return {
        cur_city: props.cur_city,
        lbsCity: props.lbsCity
    };
};
export default connect(select, null, null, { withRef: true })(City);
